import {connect} from "react-redux";
import * as taskWidgetSelector from "../../../../../state/task-widget/selector";
import * as action from "../../../../../state/task-widget/action";
import Dropdown from "./Dropdown";

const mapStateToProps = (state, props) => {
    return {
        selectedImageVersions: taskWidgetSelector.selectSelectedImageVersions(state, props.preCheckinPhotoIndex),
    }
}

const mapDispatchToProps = {
    setPhotoRejectionReason: action.setPhotoRejectionReason,
}

export default connect(mapStateToProps, mapDispatchToProps)(Dropdown)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/components/Dropdown/DropdownContainer.js